import React from "react";
import { formatDistanceWithSuffix } from "tsi-common-react/src/apps/retail/helpers";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location";
import { formatPhoneNumber } from "tsi-common-react/src/utils/format";
import { t } from "ttag";

import hoursIcon from "../../img/retail-locator/hours-icon.png";
import locationIcon from "../../img/retail-locator/location-icon.png";
import phoneIcon from "../../img/retail-locator/phone-icon.png";
import tpStoreTile from "../../img/retail-locator/tp-store-tile.jpg";
import { CMSFlagshipStorePage, CMSStoreHourDays } from "../models";

interface IProps {
    cmsProps: CMSFlagshipStorePage;
    store: IRetailStoreWithDistance;
    hoursFieldName: CMSStoreHourDays;
}

export const CMSFlagshipStore = (props: IProps): React.ReactNode => {
    // Convert distance from meters to miles
    const phoneInUSFormat = props.store.phone
        ? formatPhoneNumber(props.store.phone)
        : "";
    return (
        <div className="pdp-modal-tpstore pdp-modal__block">
            <h5 className="pdp-modal__subtitle">
                {t`Your Closest Tempur-Pedic Store`}
            </h5>
            <div className="pdp-modal-tpstore__content-container">
                <div className="pdp-modal-tpstore__img-wrapper">
                    {props.cmsProps.storefront_thumbnail && (
                        <img
                            className="pdp-modal-tpstore__img responsive-img"
                            src={tpStoreTile}
                            alt={t`${props.cmsProps.title} Storefront`}
                        />
                    )}
                    <div className="pdp-modal-tpstore__miles">
                        {formatDistanceWithSuffix(props.store.distance)}
                    </div>
                </div>
                <div className="pdp-modal-tpstore__info">
                    <h4 className="pdp-modal-tpstore__name">
                        {props.cmsProps.title}
                    </h4>
                    <div className="pdp-modal-tpstore__address">
                        <div>
                            <img src={locationIcon} alt={t`Location Icon`} />
                            {/* TODO(i18n): Address format hardcodes US-style address with comma between city and state. Use locale-aware address formatting or translate the entire address string. */}
                            <span className="pdp-modal-tpstore__marker al-more-ways-to-buy-directions">
                                {props.store.address}&nbsp;
                                {props.store.address2}&nbsp;
                                {props.store.city}, {props.store.state}
                            </span>
                        </div>
                        {phoneInUSFormat && (
                            <div>
                                <img src={phoneIcon} alt={t`Phone Icon`} />
                                <a
                                    href={`tel:${props.store.phone}`}
                                    className="pdp-modal-tpstore__phone pdp-modal__link"
                                >
                                    {phoneInUSFormat}
                                </a>
                            </div>
                        )}
                        <div>
                            <img src={hoursIcon} alt={t`Hours Icon`} />
                            <div className="pdp-modal-tpstore__time">
                                {t`Today: `}
                                {props.cmsProps[props.hoursFieldName]}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
